'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var SIZE_CLASSES = exports.SIZE_CLASSES = {
  auto: '',
  medium: 'private-modal--medium',
  short: 'private-modal--short',
  tall: 'private-modal--tall'
};

var USE_CLASSES = exports.USE_CLASSES = {
  default: 'private-modal--default',
  conversational: 'private-modal--conversational',
  info: 'private-modal--info',
  success: 'private-modal--success',
  danger: 'private-modal--danger',
  fullscreen: 'private-modal--fullscreen',
  lightbox: 'private-modal--lightbox',
  sidebar: 'private-modal--sidebar',
  upgrades: 'private-modal--upgrades'
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1282/js/dialog/DialogConstants.js
// module id = 170
// module chunks = 0